<template>
  <div class="xiaobu-container">
    <el-row :gutter="10" class="el-row-bu">
      <el-col :span="8">
        <el-card>
          <div slot="header">
            <span>缓存列表</span>
            <el-button style="float: right; padding: 3px 0" type="text" icon="el-icon-refresh-right"
              @click="refreshCacheNames()"></el-button>
          </div>
          <auto-height-table instanceHeight="238" min-height="458" ref="firstTable" :class="{ 'empty': cacheNames.length === 0 }"
            highlight-current-row empty-text=" " v-loading="loading" :data="cacheNames" @row-click="getCacheKeys">
            <el-table-column label="缓存名称" align="center" prop="dictLabel"
              :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="备注" align="center" prop="remark" :show-overflow-tooltip="true" />
            <el-table-column v-if="mixinHasPermi(['monitor:redis:deleteFolder'])" label="操作" width="60" align="center" class-name="small-padding fixed-width">
              <template slot-scope="scope">
                <el-button size="mini" type="text" icon="el-icon-delete"
                  @click="handleClearCacheName(scope.row)"></el-button>
              </template>
            </el-table-column>
          </auto-height-table>
        </el-card>
      </el-col>

      <el-col :span="8">
        <el-card>
          <div slot="header">
            <span>键名列表</span>
            <el-button style="float: right; padding: 3px 0" type="text" icon="el-icon-refresh-right"
              @click="refreshCacheKeys()"></el-button>
          </div>
          <auto-height-table instanceHeight="238" min-height="458" ref="secondTable" v-loading="subLoading"
            :class="{ 'empty': cacheKeys.length === 0 }" empty-text=" " :data="cacheKeys" highlight-current-row
            @row-click="handleCacheValue">
            <el-table-column label="缓存键名" align="center" :show-overflow-tooltip="true" :formatter="keyFormatter">
            </el-table-column>
            <el-table-column v-if="mixinHasPermi(['monitor:redis:deleteKey'])" label="操作" width="60" align="center" class-name="small-padding fixed-width">
              <template slot-scope="scope">
                <el-button size="mini" type="text" icon="el-icon-delete"
                  @click="handleClearCacheKey(scope.row)"></el-button>
              </template>
            </el-table-column>
          </auto-height-table>
        </el-card>
      </el-col>

      <el-col :span="8" class="el-card-bu">
        <el-card :bordered="false">
          <div slot="header">
            <span>缓存内容</span>
            <el-button v-hasPermission="['monitor:redis:deleteAll']" style="float: right; padding: 3px 0" type="text" icon="el-icon-refresh-right"
              @click="handleClearCacheAll()">清理全部</el-button>
          </div>
          <el-form :model="cacheForm">
            <el-row :gutter="32">
              <el-col :offset="1" :span="22">
                <el-form-item label="缓存名称:" prop="cacheName">
                  <el-input v-model="cacheForm.cacheName" :readOnly="true" />
                </el-form-item>
              </el-col>
              <el-col :offset="1" :span="22">
                <el-form-item label="缓存键名:" prop="cacheKey">
                  <el-input v-model="cacheForm.cacheKey" :readOnly="true" />
                </el-form-item>
              </el-col>
              <el-col :offset="1" :span="22">
                <el-form-item label="缓存内容:" prop="cacheValue">
                  <el-input v-model="cacheForm.cacheValue" type="textarea" :rows="8" :readOnly="true" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { cacheApi } from "@/api"
export default {
  name: "monitorRedisManage",
  data() {
    return {
      cacheRemark: "", // 最后一项 展示 缓存名称
      cacheNames: [],
      cacheKeys: [],
      cacheForm: {},
      loading: true,
      subLoading: false,
      nowCacheName: ""
    }
  },
  created() {
    this.getCacheNames()
  },
  methods: {
    /** 查询缓存名称列表 */
    getCacheNames() {
      // 清除当前高亮显示的行
      this.$refs.firstTable && this.$refs.firstTable.setCurrentRow(null)

      this.loading = true
      cacheApi.getCacheList().then(response => {
        this.cacheNames = response || []
        this.loading = false

        // 表格二清空
        this.cacheKeys = []
        // 第三部分详情 清空
        this.cacheForm = {}

      }).catch((err) => {
        if (err?.name === "CanceledError") {
          return
        }
        // 表格二清空
        this.cacheKeys = []
        // 第三部分详情 清空
        this.cacheForm = {}

        this.loading = false
      })
    },
    /** 刷新缓存名称列表 */
    refreshCacheNames() {

      this.getCacheNames()
      this.$modal.msgSuccess("刷新缓存列表成功")
    },
    /** 清理指定名称缓存 */
    handleClearCacheName(row) {
      this.$modal
        .confirm('是否确认清除缓存目录为"' + row.dictValue + '"下的所有数据项？')
        .then(function() {
          return cacheApi.delCacheByFolder({folder: row.dictValue})
        })
        .then(() => {
          this.$modal.msgSuccess("清理缓存名称[" + this.nowCacheName + "]成功")
          this.getCacheKeys()
        })
    },
    /** 查询缓存键名列表 */
    getCacheKeys(row) {
      // 清除当前高亮显示的行
      this.$refs.secondTable.setCurrentRow(null)

      // 最后一个缓存名称 使用 
      this.cacheRemark = row ? row.remark : this.cacheRemark

      const cacheName = row ? row.dictValue : this.nowCacheName
      if (cacheName === "") {
        return
      }
      this.subLoading = true
      cacheApi.getCacheKeyList({ folder: cacheName }).then(response => {
        this.cacheKeys = response
        this.subLoading = false
        this.nowCacheName = cacheName

        // 清空第三项
        this.cacheForm = {}
      }).catch((err) => {
        if (err?.name === "CanceledError") {
          return
        }
        // 清空第三项
        this.cacheForm = {}
        this.subLoading = false
      })
    },
    /** 刷新缓存键名列表 */
    refreshCacheKeys() {
      this.getCacheKeys()
      this.$modal.msgSuccess("刷新键名列表成功")
    },
    /** 清理指定键名缓存 */
    handleClearCacheKey(cacheKey) {
      this.$modal
        .confirm('是否确认清除缓存键名为"' +cacheKey + '"的数据项？')
        .then(function() {
          return cacheApi.delCacheByKey({key: cacheKey})
        })
        .then(() => {
          this.$modal.msgSuccess("清理缓存键名[" + cacheKey + "]成功")
          this.getCacheKeys()
        })
    },
    /** 列表前缀去除 */
    nameFormatter(row) {
      return row.cacheName.replace(":", "")
    },
    /** 键名前缀去除 */
    keyFormatter(cacheKey) {
      return cacheKey.replace(this.nowCacheName + ":", "")
    },
    /** 查询缓存内容详细 */
    handleCacheValue(cacheKey) {
      cacheApi.getCacheInfo({ key: cacheKey }).then(response => {
        this.cacheForm = {
          cacheName: this.cacheRemark,
          cacheKey: response.key,
          cacheValue: response.cacheData
        }
      })
    },
    /** 清理全部缓存 */
    handleClearCacheAll() {
      this.$modal
        .confirm("清除全部缓存会导致您不可继续使用系统，需重新登陆，是否继续？")
        .then(function() {
          return cacheApi.flushAllRedis()
        })
        .then(() => {
          this.getCacheNames()
          this.$modal.msgSuccess("清理全部缓存成功")
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.xiaobu-container {
  padding: 16px;

  .el-table {
    width: 100%;
    border-radius: 4px;
    &::before{
      content: none !important;
    }

    &.empty {
      &::after {
        content: "暂无数据";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, 50%, 0);
        color: #909399;
      }

      // 无数据时 右侧滚动条被盖住 无法滚动
      .el-table__fixed-right {
        height: calc(100% - 16px) !important; //设置高优先，以覆盖内联样式
      }

      // 设置表格无数据时高度
      .el-table__empty-block {
        height: 128px !important;
      }
    }

    // 解决表格右侧设置 fixed时  有时候最后一行fixed的内容显示不全的问题
    .el-table__body-wrapper {
      &.is-scrolling-none {
        &+.el-table__fixed-right {
          height: 100% !important; //设置高优先，以覆盖内联样式
        }
      }

      &.is-scrolling-left,
      &.is-scrolling-middle,
      &.is-scrolling-right {
        &+.el-table__fixed-right {
          height: calc(100% - 16px) !important; //设置高优先，以覆盖内联样式
        }
      }
    }

    .operater-box {
      width: 100%;

      .operater-content-box {
        align-items: flex-start;
        max-width: 100%;

        .top,
        .bottom {
          white-space: nowrap;
          text-align: left;
        }
      }
    }
  }

  .el-row-bu {
    display: flex;

    .el-card-bu {
      .el-card {
        height: 100%;

      }
    }
  }

  ::v-deep .el-card__body {
    padding: 12px !important;
    padding-top: 0 !important;
  }
}
</style>